import {
  createStyles, rem, useMantineTheme,
} from '@mantine/core';
import logoLight from '../../assets/logo_light.svg';
import logoDark from '../../assets/logo_dark.svg';
import { getTypographyStyles } from '../../theme/themeConfig';
// import Toggle from './toggle';

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    wrapper: {
      height: rem(theme.other.navHeight),
      width: '100%',
      backgroundColor: colors.base.white,
      // boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
      borderBottom: `1px solid ${colors.disabled.muted}`,
      color: colors.primary.default,
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        height: rem(theme.other.navHeightMobile),
        backgroundColor: colors.bg.default,
        display: 'none',
      },
    },
    nav: {
      maxWidth: '1280px',
      height: '100%',
      padding: '1rem',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    leftWrapper: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    logo: {
      height: 32,
      borderRight: `1px solid ${colors.disabled.muted}`,
      paddingRight: 32,
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        paddingRight: 16,
        height: 24,
        marginLeft: 16,
      },
    },
    navBarText: {
      color: colors.primary.default,
      paddingLeft: 32,
      ...getTypographyStyles('heading_md_regular'),
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        paddingLeft: 16,
        ...getTypographyStyles('heading_xs_regular'),
      },
    },
    navBarSubText: {
      color: colors.primary.default,
      ...getTypographyStyles('heading_md_bold'),
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        ...getTypographyStyles('heading_xs_bold'),
      },
    },
  };
});
const getLogo = (mode: 'dark' | 'light') => {
  if (mode === 'light') {
    return logoDark;
  } return logoLight;
};
const Navbar = () => {
  const { classes } = useStyles();
  const theme = useMantineTheme();

  return (
    <nav className={classes.wrapper}>
      <div className={classes.nav}>
        <div className={classes.leftWrapper}>
          <img className={classes.logo} src={getLogo(theme.colorScheme)} alt="Logo TIQS" />
          <p className={classes.navBarText}>
            Blazing Fast
            {' '}
            <span className={classes.navBarSubText}>Trading</span>
            {' '}
          </p>
        </div>
        {/* <Toggle /> */}
      </div>
    </nav>
  );
};

export default Navbar;
